var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1920 120.556L1846.13 112.63C1770.03 104.704 1622.3 88.8519 1472.33 136.407C1322.36 183.963 1182.47 271.074 1032.5 279C882.532 286.926 726.968 215.667 577 191.889C427.032 168.111 279.302 215.667 129.333 215.667C-20.6351 215.667 -168.365 168.111 -318.333 136.407C-468.302 104.704 -616.032 88.8519 -692.135 80.9259L-766 73V501H-692.135C-616.032 501 -468.302 501 -318.333 501C-168.365 501 -20.6351 501 129.333 501C279.302 501 427.032 501 577 501C726.968 501 874.698 501 1024.67 501C1174.63 501 1322.36 501 1472.33 501C1622.3 501 1770.03 501 1846.13 501H1920V120.556Z",
    fill: "#C3E9F1",
    fillOpacity: 0.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.99963 280.256L59.0681 262.338C123.136 244.42 252.364 178.819 380.5 187.306C507.618 196.736 622.458 225.515 750.594 261.351C878.729 297.187 1127.36 358.001 1255.5 295.76C1382.62 232.576 1405.46 223.144 1533.59 169.39C1661.73 115.636 1789.86 151.472 1853.93 169.39L1918 187.308L1918 220.73L1853.93 202.812C1789.86 184.894 1661.73 149.059 1533.59 202.812C1405.46 256.566 1382.62 265.998 1255.5 329.182C1127.36 391.424 878.729 330.609 750.593 294.773C622.457 258.937 507.618 230.159 380.5 220.728C252.364 212.241 123.136 277.842 59.0678 295.76L-5 313.678L-4.99963 280.256Z",
    fill: "#C3E9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14843e-05 291.373L50.0697 274.984C114.137 258.595 243.366 198.593 371.501 206.356C498.62 214.981 613.459 241.304 741.595 274.081C914.502 312.405 1173.5 334.108 1355.5 261.901C1486.05 210.107 1407.46 239.133 1535.59 189.967C1663.73 140.801 1791.86 173.578 1855.93 189.967L1920 206.356V1051H1855.93C1791.86 1051 1663.73 1051 1535.59 1051C1407.46 1051 1279.32 1051 1152.2 1051C1024.07 1051 895.932 1051 767.797 1051C639.661 1051 511.526 1051 384.407 1051C256.271 1051 128.136 1051 64.0678 1051H0L4.14843e-05 291.373Z",
    fill: "url(#paint0_linear_2448_2131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14843e-05 291.373L50.0697 274.984C114.137 258.595 243.366 198.593 371.501 206.356C498.62 214.981 613.459 241.304 741.595 274.081C914.502 312.405 1173.5 334.108 1355.5 261.901C1486.05 210.107 1407.46 239.133 1535.59 189.967C1663.73 140.801 1791.86 173.578 1855.93 189.967L1920 206.356V1051H1855.93C1791.86 1051 1663.73 1051 1535.59 1051C1407.46 1051 1279.32 1051 1152.2 1051C1024.07 1051 895.932 1051 767.797 1051C639.661 1051 511.526 1051 384.407 1051C256.271 1051 128.136 1051 64.0678 1051H0L4.14843e-05 291.373Z",
    fill: "url(#paint1_linear_2448_2131)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 580.303L52.8 570.736C107.2 561.169 212.8 542.035 320 542.035C427.2 542.035 532.8 561.169 640 570.736C747.2 580.303 852.8 580.303 960 551.602C1067.2 522.9 1172.8 465.498 1280 436.797C1387.2 408.096 1492.8 408.096 1600 417.663C1707.2 427.23 1812.8 446.364 1867.2 455.931L1920 465.498V235.889H1867.2C1812.8 235.889 1707.2 235.889 1600 235.889C1492.8 235.889 1387.2 235.889 1280 235.889C1172.8 235.889 1067.2 235.889 960 235.889C852.8 235.889 747.2 235.889 640 235.889C532.8 235.889 427.2 235.889 320 235.889C212.8 235.889 107.2 235.889 52.8 235.889H0V580.303Z",
    fill: "url(#paint2_linear_2448_2131)",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-549 911.971L-462.2 863.096C-375.4 814.221 -201.8 716.47 -28.2 726.246C145.4 736.021 319 853.321 492.6 882.646C666.2 911.971 839.8 853.321 1013.4 814.221C1187 775.121 1360.6 755.571 1534.2 784.896C1707.8 814.221 1881.4 892.421 1968.2 931.521L2055 970.621V501.42H1968.2C1881.4 501.42 1707.8 501.42 1534.2 501.42C1360.6 501.42 1187 501.42 1013.4 501.42C839.8 501.42 666.2 501.42 492.6 501.42C319 501.42 145.4 501.42 -28.2 501.42C-201.8 501.42 -375.4 501.42 -462.2 501.42H-549V911.971Z",
    fill: "url(#paint3_linear_2448_2131)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2448_2131",
    x1: 960.001,
    y1: 1014.59,
    x2: 960.001,
    y2: -110.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130556,
    stopColor: "#002A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689869,
    stopColor: "#009ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933485,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2448_2131",
    x1: 960,
    y1: 164,
    x2: 960,
    y2: 1051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00095F",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2448_2131",
    x1: 960,
    y1: 580.303,
    x2: 960,
    y2: 235.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E3FF",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2448_2131",
    x1: 753,
    y1: 970.621,
    x2: 753,
    y2: 501.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackground);
export default __webpack_public_path__ + "static/media/footer_background.9251e83918587e82988cdd2c63880a25.svg";
export { ForwardRef as ReactComponent };